import React from 'react';
import PropTypes from 'prop-types';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import TextField from 'material-ui/TextField';
import Paper from 'material-ui/Paper';
import { MenuItem } from 'material-ui/Menu';
import { withStyles } from 'material-ui/styles';
import axios from 'axios';
import $ from 'jquery';

const suggestions = [
  // { label: 'Afghanistan' },
  // { label: 'Aland Islands' },
  // { label: 'Albania' },
  // { label: 'Algeria' },
  // { label: 'American Samoa' },
  // { label: 'Andorra' },
  // { label: 'Angola' },
  // { label: 'Anguilla' },
  // { label: 'Antarctica' },
  // { label: 'Antigua and Barbuda' },
  // { label: 'Argentina' },
  // { label: 'Armenia' },
  // { label: 'Aruba' },
  // { label: 'Australia' },
  // { label: 'Austria' },
  // { label: 'Azerbaijan' },
  // { label: 'Bahamas' },
  // { label: 'Bahrain' },
  // { label: 'Bangladesh' },
  // { label: 'Barbados' },
  // { label: 'Belarus' },
  // { label: 'Belgium' },
  // { label: 'Belize' },
  // { label: 'Benin' },
  // { label: 'Bermuda' },
  // { label: 'Bhutan' },
  // { label: 'Bolivia, Plurinational State of' },
  // { label: 'Bonaire, Sint Eustatius and Saba' },
  // { label: 'Bosnia and Herzegovina' },
  // { label: 'Botswana' },
  // { label: 'Bouvet Island' },
  // { label: 'Brazil' },
  // { label: 'British Indian Ocean Territory' },
  // { label: 'Brunei Darussalam' },
];

function renderInput(inputProps) {
  const { classes, ref, ...other } = inputProps;

  return (
    <TextField
      fullWidth
      InputProps={{
        inputRef: ref,
        classes: {
          input: classes.input,
        },
        ...other,
      }}
    />
  );
}

function renderSuggestion(suggestion, { query, isHighlighted }) {
  const matches = match(suggestion.label, query);
  const parts = parse(suggestion.label, matches);

  return (
    <MenuItem className="popup-value-size" selected={isHighlighted} component="div">
      <div>
        {parts.map((part, index) => {
          return part.highlight ? (
            <span key={String(index)} style={{ fontWeight: 300 }}>
              {part.text}
            </span>
          ) : (
            <strong key={String(index)} style={{ fontWeight: 500 }}>
              {part.text}
            </strong>
          );
        })}
      </div>
    </MenuItem>
  );
}

function renderSuggestionsContainer(options) {
  const { containerProps, children } = options;

  return (
    <Paper {...containerProps} square>
      {children}
    </Paper>
  );
}

function getSuggestionValue(suggestion) {
  return suggestion.label;
}

function getSuggestions(value) {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;
  let count = 0;

  return inputLength === 0
    ? []
    : suggestions.filter(suggestion => {
        const keep =
          count < 5 && suggestion.label.toLowerCase().slice(0, inputLength) === inputValue;

        if (keep) {
          count += 1;
        }

        return keep;
      });
}

const styles = theme => ({
  container: {
    flexGrow: 1,
    position: 'relative',
    height: 250,
  },
  suggestionsContainerOpen: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0,
  },
  suggestion: {
    display: 'block',
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  },
});

class IntegrationAutosuggest extends React.Component {
  state = {
    value: '',
    suggestions: [],
  };

  constructor(props){
    super(props);
    this.getEmployeeDetails();
  }

  //   // get employee details for loding into the drop down
  getEmployeeDetails() {

    axios.get(window.hrmServer +'/getEmployeeDetails')
      .then(res => {
        if (res.data.success) {

          var employeeDetailObj = res.data.result;
          // console.log("2nd anme "+ this.state.data[0].ID_EMPLOYEE_REGISTRY);
          // alert('Success ' + employeeDetailObj[0].ID_EMPLOYEE_REGISTRY);

          for (var i = 0; i < employeeDetailObj.length; i++) {

            suggestions.push({
              label: employeeDetailObj[i].NIC
              // refNo: employeeDetailObj[i].REF_NO,
              // epfCpf: employeeDetailObj[i].EPF_CPF
            });
          }

          // this.setState({ employeeData: employeeData });
          // var customerObj = res.data.result;
          // // console.log(this.state.data[0].firstName);
          // // this.state.data[0].firstName="susss";
          // // console.log("2nd anme "+ this.state.data[0].firstName);
          // for (var i = 0; i < customerObj.length; i++) {
          //     // console.log(customerObj[i].name);
          //     this.state.data1[i] = {
          //         "firstName": customerObj[i].name,
          //         "lastName": customerObj[i].age,
          //         "visits": customerObj[i].id
          //     }

          // }
          // console.log(this.state.data1[0].visits);

          // alert("al " + suggestions.length);
        } else {
          alert('Ivalid Credentials');
        }
      })
      // alert("end");
  }

  handleSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: getSuggestions(value),
    });
  };

  handleSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  handleChange = (event, { newValue }) => {
    this.setState({
      value: newValue,
    });

    alert('nic val '+ this.refs.searchNicNo.value);
    this.props.callback($('#searchNicNo').val());
  };

  render() {
    const { classes } = this.props;

    return (
      <Autosuggest
        theme={{
          container: classes.container,
          suggestionsContainerOpen: classes.suggestionsContainerOpen,
          suggestionsList: classes.suggestionsList,
          suggestion: classes.suggestion,
        }}
        renderInputComponent={renderInput}
        suggestions={this.state.suggestions}
        onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
        renderSuggestionsContainer={renderSuggestionsContainer}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={{
          classes,
          placeholder: this.props.placeholder.ph,
          value: this.state.value,
          onChange: this.handleChange,
        }}
        ref="searchNicNo"
        id="searchNicNo"
      />
    );
  }
}

IntegrationAutosuggest.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(IntegrationAutosuggest);

// import React from 'react';
// import PropTypes from 'prop-types';
// import keycode from 'keycode';
// import Downshift from 'downshift';
// import { withStyles } from 'material-ui/styles';
// import TextField from 'material-ui/TextField';
// import Paper from 'material-ui/Paper';
// import { MenuItem } from 'material-ui/Menu';
// import Chip from 'material-ui/Chip';
// import axios from 'axios';

// const suggestions = [
//   // { label: 'Afghanistan' },
//   // { label: 'Aland Islands' },
//   // { label: 'Albania' },
//   // { label: 'Algeria' },
//   // { label: 'American Samoa' },
//   // { label: 'Andorra' },
//   // { label: 'Angola' },
//   // { label: 'Anguilla' },
//   // { label: 'Antarctica' },
//   // { label: 'Antigua and Barbuda' },
//   // { label: 'Argentina' },
//   // { label: 'Armenia' },
//   // { label: 'Aruba' },
//   // { label: 'Australia' },
//   // { label: 'Austria' },
//   // { label: 'Azerbaijan' },
//   // { label: 'Bahamas' },
//   // { label: 'Bahrain' },
//   // { label: 'Bangladesh' },
//   // { label: 'Barbados' },
//   // { label: 'Belarus' },
//   // { label: 'Belgium' },
//   // { label: 'Belize' },
//   // { label: 'Benin' },
//   // { label: 'Bermuda' },
//   // { label: 'Bhutan' },
//   // { label: 'Bolivia, Plurinational State of' },
//   // { label: 'Bonaire, Sint Eustatius and Saba' },
//   // { label: 'Bosnia and Herzegovina' },
//   // { label: 'Botswana' },
//   // { label: 'Bouvet Island' },
//   // { label: 'Brazil' },
//   // { label: 'British Indian Ocean Territory' },
//   // { label: 'Brunei Darussalam' },
// ];

// function renderInput(inputProps) {
//   const { InputProps, classes, ref, ...other } = inputProps;

//   return (
//     <TextField
//       InputProps={{
//         inputRef: ref,
//         classes: {
//           root: classes.inputRoot,
//         },
//         ...InputProps,
//       }}
//       {...other}
//     />
//   );
// }

// function renderSuggestion({ suggestion, index, itemProps, highlightedIndex, selectedItem }) {
//   const isHighlighted = highlightedIndex === index;
//   const isSelected = (selectedItem || '').indexOf(suggestion.label) > -1;

//   return (
//     <MenuItem
//       {...itemProps}
//       key={suggestion.label}
//       selected={isHighlighted}
//       component="div"
//       style={{
//         fontWeight: isSelected ? 500 : 400,
//       }}
//     >
//       {suggestion.label}
//     </MenuItem>
//   );
// }
// renderSuggestion.propTypes = {
//   highlightedIndex: PropTypes.number,
//   index: PropTypes.number,
//   itemProps: PropTypes.object,
//   selectedItem: PropTypes.string,
//   suggestion: PropTypes.shape({ label: PropTypes.string }).isRequired,
// };

// function getSuggestions(inputValue) {
//   let count = 0;

//   return suggestions.filter(suggestion => {
//     // alert(suggestion.label);

    
//     if (null != suggestion.label) {
//       const keep =
//       (!inputValue || suggestion.label.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1) &&
//         count < 5;

//       if (keep) {
//         count += 1;
//       }
//       return keep;
//     }

//   });
// }

// class DownshiftMultiple extends React.Component {

//   constructor(props) {
//     super(props);
//     this.getEmployeeDetails();

//     // alert(this.props.placeholder.ph);
//     // console.log(this.props.passData.name);
//   }

//   // componentDidUpdate(nextProps, nextState){
//   //   console.log("nic "+this.props.employeeData.length>0?this.props.employeeData[0].nicSsn:0);
//   //   alert("nic "+this.props.employeeData.length>0?this.props.employeeData[0].nicSsn:0);
//   // }


//   // get employee details for loding into the drop down
//   getEmployeeDetails() {

//     axios.get('http://localhost:5002/getEmployeeDetails')
//       .then(res => {

//         if (res.data.success) {

//           var employeeDetailObj = res.data.result;
//           // console.log("2nd anme "+ this.state.data[0].ID_EMPLOYEE_REGISTRY);
//           // alert('Success ' + employeeDetailObj[0].ID_EMPLOYEE_REGISTRY);

//           for (var i = 0; i < employeeDetailObj.length; i++) {

//             suggestions.push({
//               label: employeeDetailObj[i].NIC
//               // refNo: employeeDetailObj[i].REF_NO,
//               // epfCpf: employeeDetailObj[i].EPF_CPF
//             });
//           }

//           // this.setState({ employeeData: employeeData });
//           // var customerObj = res.data.result;
//           // // console.log(this.state.data[0].firstName);
//           // // this.state.data[0].firstName="susss";
//           // // console.log("2nd anme "+ this.state.data[0].firstName);
//           // for (var i = 0; i < customerObj.length; i++) {
//           //     // console.log(customerObj[i].name);
//           //     this.state.data1[i] = {
//           //         "firstName": customerObj[i].name,
//           //         "lastName": customerObj[i].age,
//           //         "visits": customerObj[i].id
//           //     }

//           // }
//           // console.log(this.state.data1[0].visits);

//           // alert("al " + suggestions.length);
//         } else {
//           alert('Ivalid Credentials');
//         }
//       })
//   }

//   state = {
//     inputValue: '',
//     selectedItem: [],
//   };

//   handleKeyDown = event => {
//     const { inputValue, selectedItem } = this.state;
//     if (selectedItem.length && !inputValue.length && keycode(event) === 'backspace') {
//       this.setState({
//         selectedItem: selectedItem.slice(0, selectedItem.length - 1),
//       });
//     }
//   };

//   handleInputChange = event => {
//     this.setState({ inputValue: event.target.value });
//   };

//   handleChange = item => {
//     let { selectedItem } = this.state;

//     if (selectedItem.indexOf(item) === -1) {
//       selectedItem = [...selectedItem, item];
//     }

//     this.setState({
//       inputValue: '',
//       selectedItem,
//     });
//   };

//   handleDelete = item => () => {
//     const selectedItem = [...this.state.selectedItem];
//     selectedItem.splice(selectedItem.indexOf(item), 1);

//     this.setState({ selectedItem });
//   };

//   render() {

//     const { classes } = this.props;
//     const { inputValue, selectedItem } = this.state;

//     return (

//       <Downshift inputValue={inputValue} onChange={this.handleChange} selectedItem={selectedItem}>
//         {({
//           getInputProps,
//           getItemProps,
//           isOpen,
//           inputValue: inputValue2,
//           selectedItem: selectedItem2,
//           highlightedIndex,
//         }) => (
//             <div className={classes.container}>
//               {renderInput({
//                 fullWidth: true,
//                 classes,
//                 InputProps: getInputProps({
//                   startAdornment: selectedItem.map(item => (
//                     <Chip
//                       key={item}
//                       tabIndex={-1}
//                       label={item}
//                       className={classes.chip}
//                       onDelete={this.handleDelete(item)}
//                     />
//                   )),
//                   onChange: this.handleInputChange,
//                   onKeyDown: this.handleKeyDown,
//                   // placeholder: this.props.employeeData.length>0?this.props.employeeData[0].nicSsn:0, 
//                   placeholder : this.props.placeholder.ph,
//                   id: 'searchNicNo',
//                 }),
//               })}
//               {isOpen ? (
//                 <Paper className={classes.paper} square>
//                   {getSuggestions(inputValue2).map((suggestion, index) =>
//                     renderSuggestion({
//                       suggestion,
//                       index,
//                       itemProps: getItemProps({ item: suggestion.label }),
//                       highlightedIndex,
//                       selectedItem: selectedItem2,
//                     }),
//                   )}
//                 </Paper>
//               ) : null}
//             </div>
//           )}
//       </Downshift>
//     );
//   }
// }

// DownshiftMultiple.propTypes = {
//   classes: PropTypes.object.isRequired,
// };

// const styles = theme => ({
//   root: {
//     flexGrow: 1,
//     height: 250,
//   },
//   container: {
//     flexGrow: 1,
//     position: 'relative',
//   },
//   paper: {
//     position: 'absolute',
//     zIndex: 1,
//     marginTop: theme.spacing.unit,
//     left: 0,
//     right: 0,
//   },
//   chip: {
//     margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`,
//   },
//   inputRoot: {
//     flexWrap: 'wrap',
//   },
// });

// function IntegrationDownshift(props) {
//   const { classes } = props;

//   return (
//     <div className={classes.root}>
//       <Downshift>
//         {({ getInputProps, getItemProps, isOpen, inputValue, selectedItem, highlightedIndex }) => (
//           <div className={classes.container}>
//             {renderInput({
//               fullWidth: true,
//               classes,
//               InputProps: getInputProps({
//                 placeholder: this.props.placeholder.ph,
//                 id: 'searchNicNo',
//               }),
//             })}
//             {isOpen ? (
//               <Paper className={classes.paper} square>
//                 {getSuggestions(inputValue).map((suggestion, index) =>
//                   renderSuggestion({
//                     suggestion,
//                     index,
//                     itemProps: getItemProps({ item: suggestion.label }),
//                     highlightedIndex,
//                     selectedItem,
//                   }),
//                 )}
//               </Paper>
//             ) : null}
//           </div>
//         )}
//       </Downshift>
//       <DownshiftMultiple classes={classes} />
//     </div>
//   );
// }

// IntegrationDownshift.propTypes = {
//   classes: PropTypes.object.isRequired,
// };

// export default withStyles(styles)(DownshiftMultiple);


// WEBPACK FOOTER //
// ./src/main/content/hr/extenalComponents/IntegrationAutosuggest.js